import { call, put } from 'redux-saga/effects';
import { BACKEND_URL } from '../../../configs';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';

import { editLostTicketFailed, editLostTicketSuccessful } from '../actions';
import { OK } from '../../../configs/serverStatusCodes';
import makeRequest from '../../../utils/makeRequest';
import processError from '../../../utils/processError';

export default function* editLostTicket(action) {
  try {
    const pool = action.payload;

    const url = `${BACKEND_URL}/proxy/tariff/v1/lost-tickets/${pool?.id}`;
    const dataResponse = yield makeRequest(url, pool, action, 'PATCH', true);
    const data = yield dataResponse.json();

    if (dataResponse.status === OK) {
      yield put(editLostTicketSuccessful(data.data));
      yield call(resolveActionPromise(action, data.data));
    } else {
      yield put(editLostTicketFailed([]));
      yield call(rejectActionPromise(action, data));
    }
  } catch (e) {
    yield put(editLostTicketFailed([]));
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
